import $ from 'jquery';
import 'slick-carousel';
import getLayout from './get-modal-layout';
import {getSiblings} from './utils';
import Modal from './modal';

const classNames = {
  options: {
    optionActive: `modal-floors__option--active`
  },
  footer: {
    static: `page-footer--static`,
    hidden: `page-footer--hidden`
  },
  logo: {
    hidden: `logo--hidden`
  }
};
const texts = {
  floor: {
    ru: `этаж`,
    en: `floor`,
    cn: `楼层`
  }
};

//TODO: refactor modals creation
class ModalFloors extends Modal {
  constructor() {
    super();
    this.footer = this.page.querySelector(`.page-footer`);
    this.logo = this.page.querySelector(`.logo`);
    this.toggle = this.page.querySelector(`.js-gallery-floor`);
    this.plans = [];
    this.wrap = null;
    this.slider = null;
    this.options = null;
    this.activeFloor = 0;
  }

  init(plans, locale) {
    this.locale = locale;
    this.plans = this.sortFloors(plans);
    super.createModal();
    this.createFloorsWrap();
    this.bindHandlers();
  };

  sortFloors([...floors] = []) {
    return floors.sort((a, b) => {
      return a[`floor_number`] < b[`floor_number`] ? -1 : 1;
    });
  };

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
    this.logo.classList.add(classNames.logo.hidden);
    this.footer.classList.add(classNames.footer.hidden);
  };

  onClose = () => {
    this.logo.classList.remove(classNames.logo.hidden);
    this.footer.classList.remove(classNames.footer.hidden);
  };

  createFloorsWrap() {
    super.addLayout(getLayout(`flat-floors`));
    this.createFloorsItems();
  };

  createFloorsItems() {
    const wrap = this.page.querySelector(`#floors-modal`);
    const list = document.createElement(`ul`);
    const items = this.renderFloorsLayout(this.plans);
    let options;

    list.className = `modal-floors__slider modal-slider`;
    list.innerHTML = items;
    wrap.appendChild(list);

    if (this.plans.length > 1) {
      options = this.renderListOptions(this.plans);
      wrap.appendChild(options);

      this.options = [...this.page.querySelectorAll(`.modal-floors__option`)];
      this.slider = list;
      this.initSlider();
    }

    this.wrap = wrap;
  };

  initSlider = () => {
    $(this.slider).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true
    });

    $(this.slider).on('beforeChange', (event, slick, currentSlide) => {

      this.toggleOptionsState(this.options[Number(!currentSlide)]);
    });
  };

  renderListOptions(plans) {
    const wrap = document.createElement(`div`);
    const renderOption = ({floor_number: number}) => {
      return `<div class="modal-floors__option">${number} ${texts[`floor`][this.locale]}</div>`
    };
    const options = plans.map(renderOption).join(``);

    wrap.className = `modal-floors__options`;
    wrap.innerHTML = options;

    return wrap;
  };

  setActiveFloor() {
    const controls = [...this.page.querySelectorAll(`.js-gallery-control`)];

    controls.forEach((control, index) => {
      if (control.classList.contains(`flat-page__info--active`)) {
        this.activeFloor = index;
      }
    });

    // $(this.slider).slick('slickGoTo', this.activeFloor - 1, true);
    $(this.slider).slick('slickGoTo', this.activeFloor, true);
    this.toggleOptionsState(this.options[this.activeFloor]);
  };

  renderFloorsLayout = (plans) => {
    const renderPlan = (plan) => {
      const floorPlan = plan[`floor_plan_${this.locale}`] || plan[`floor_plan`];

      if (!floorPlan) return;

      return `<div class="modal-floors__floor">
                <img src="${floorPlan}" alt="Планировка этажа">
              </div>`
    };

    return plans.map(renderPlan).join(``);
  };

  optionsHandler() {
    this.options.forEach((option, index) => {
      option.addEventListener(`click`, () => {
        $(this.slider).slick('slickGoTo', index);
      })
    })
  };

  toggleOptionsState = (option) => {
    const siblings = getSiblings(option);

    option.classList.add(classNames.options.optionActive);
    siblings.forEach(sibling => sibling.classList.remove(classNames.options.optionActive));
  };

  bindHandlers() {
    this.toggle.addEventListener(`click`, (ev) => {
      ev.preventDefault();

      if (this.plans.length > 1) {
        this.setActiveFloor();
      }

      this.toggleModal(true);
    });

    if (this.plans.length > 1) {
      this.optionsHandler();
    }
  }
}

const modalFloors = new ModalFloors();

export default modalFloors;
